export const getActivePageUrl = (
	contentId: string,
	draftShareId: string | undefined,
	spaceKey: string,
) =>
	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	`${window.location.origin}/wiki/spaces/${spaceKey}/pages/edit-v2/${contentId}/?draftShareId=${draftShareId}`;
